(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ll-story-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const open = event.target.closest('[data-ll-open]');
  if (open) { const dialog = document.getElementById(open.dataset.llOpen); if (dialog) dialog.showModal(); }
  const close = event.target.closest('[data-ll-close]');
  if (close) close.closest('dialog').close();
  const view = event.target.closest('[data-ll-view]');
  if (view) { const dialog = view.closest('dialog'); dialog.querySelectorAll('[data-ll-view-image]').forEach(function(img) { img.hidden = img.dataset.llViewImage !== view.dataset.llView; }); dialog.querySelectorAll('[data-ll-view]').forEach(function(button) { button.setAttribute('aria-pressed', String(button === view)); }); }
  if (event.target.matches('dialog.ll-dialog')) { const rect = event.target.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close(); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
